module.exports = __webpack_public_path__ + "9c237a1a6b124a1f10e0ce2eef6d7036.svg";